
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"14","viewBox":"0 0 19 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.775 6.65a2.368 2.368 0 002.365-2.375A2.368 2.368 0 0013.775 1.9a2.376 2.376 0 000 4.75zM6.65 5.7a2.838 2.838 0 002.84-2.85A2.838 2.838 0 006.65 0 2.846 2.846 0 003.8 2.85 2.846 2.846 0 006.65 5.7zm7.125 2.85c-1.739 0-5.225.874-5.225 2.612v1.188c0 .523.427.95.95.95h8.55c.523 0 .95-.428.95-.95v-1.188c0-1.738-3.486-2.612-5.225-2.612zM6.65 7.6C4.436 7.6 0 8.711 0 10.925v1.425c0 .523.427.95.95.95h5.7v-2.138c0-.807.313-2.223 2.252-3.296C8.075 7.695 7.277 7.6 6.65 7.6z","fill":"#ADA3BF"}})])
          )
        }
      }
    